/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Toggle_BeforeInputs */

const et_difference_toggle_before = /** @type {(inputs: Difference_Toggle_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enne`)
};

const en_difference_toggle_before = /** @type {(inputs: Difference_Toggle_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before`)
};

/**
* | output |
* | --- |
* | "Before" |
*
* @param {Difference_Toggle_BeforeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_toggle_before = /** @type {((inputs?: Difference_Toggle_BeforeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Toggle_BeforeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_toggle_before(inputs)
	return en_difference_toggle_before(inputs)
});